/**
* Resource Cards JS
* -----------------------------------------------------------------------------
*
* All the JS for the Resource Cards component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'resource-cards',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );

      $( '.resource-cards .slider' ).each( function() {
        if ( $( this ).hasClass( 'slider--image' ) || $( this ).hasClass( 'slider--video' ) ) {
          $( this ).slick( {
            dots: false,
            arrows: false,
            variableWidth: true,
            slidesToShow: 3,
            infinite: false,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 2,
                },
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                },
              },
            ],
          } );
        } else {
          $( this ).slick( {
            dots: false,
            arrows: false,
            variableWidth: true,
            slidesToShow: 3,
            infinite: false,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 2,
                },
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                },
              },
            ],
          } );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'resource-cards', COMPONENT );
} )( app );
